import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { Subject, takeUntil } from 'rxjs';

import { UserProfile } from '../../core/interfaces/user-profile';
import { ERoutes } from '../../core/enums/routes.enum';

import { AuthService } from '../../core/services/auth.service';
import { TripsService } from '../../core/services/trips.service';
import { BreakpointService } from '../../core/services/breakpoint.service';
import { UserAccountService } from '../../core/services/user-account.service';
import { FavoritesProviderService } from '../../core/services/favorites-provider.service';
import {
  GoogleAnalyticService,
  HeaderDesktopEvent,
} from '../../core/services/google-analytic.service';
import { SsrHelperService } from '../../core/services/ssr-helper.service';

@Component({
  selector: 'app-user-account',
  templateUrl: './user-account.component.html',
  styleUrls: ['./user-account.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UserAccountComponent implements OnInit, OnDestroy {
  public readonly eRoutes = ERoutes;
  public userProfile: UserProfile;
  public pageIndex = 0;

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public authService: AuthService,
    private router: Router,
    private googleAnalyticService: GoogleAnalyticService,
    protected breakpointService: BreakpointService,
    protected favoritesProviderService: FavoritesProviderService,
    protected userAccountService: UserAccountService,
    protected tripsService: TripsService,
    protected ssrHelperService: SsrHelperService,
  ) {}

  ngOnInit(): void {
    if (!this.ssrHelperService.userAgent) return;
    this.checkUserSession();
    this.favoritesProviderService.waitForUserId().subscribe(() => {
      this.userProfile = this.authService.userProfile;
    });
    this.pageIndex = this.router.url.includes(ERoutes.MY_TRIPS) ? 0 : 1;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public changeTab(event: any): void {
    if (event === this.eRoutes.SETTINGS) {
      this.setHeaderAnalytic('pesonal settings');
    }

    this.router.navigate([ERoutes.ACCOUNT, event]).then();
  }

  setHeaderAnalytic(event: HeaderDesktopEvent): void {
    if (this.breakpointService.isMobile()) {
      this.googleAnalyticService.setHeaderMobileAnalytic({
        header_click: event,
        userID: this.authService.userId,
      });
    } else {
      this.googleAnalyticService.setHeaderDesktopAnalytic({
        header_click: event,
        userID: this.authService.userId,
      });
    }
  }

  private checkUserSession(): void {
    this.authService.isLogged$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isLogged: boolean) => {
        if (!isLogged) {
          this.router.navigate([ERoutes.EMPTY]).then();
        }
      });
  }
}
